import { render } from "./HistoryComponent.vue?vue&type=template&id=22148658"
import script from "./HistoryComponent.vue?vue&type=script&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__